import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { LinkVariant } from 'api/contentful/contentTypes.cloverdotcom';
import { SproutButton } from 'components/Button/SproutButton';
import styles from './ItemOutOfStock.module.scss';

export const ItemOutOfStockButton: FC = () => {
  const { t } = useTranslation();

  return (
    <>
      <SproutButton className={styles.button} variant={LinkVariant.SECONDARY} size="small">
        {t('build-your-own.item.button.outOfStock')}
      </SproutButton>
    </>
  );
};
